export default __webpack_public_path__ + "assets/f7706bf3bba2b30e94447edd6306b0ad.svg";